import React, { useContext, useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { useTranslation, Trans } from "react-i18next";
import Modal from 'react-bootstrap/Modal';
import Stack from 'react-bootstrap/Stack';
import FormFileUpload from "./../inputs/fileupload";
import FormSelect from './../inputs/select';
import Button from 'react-bootstrap/Button';
import Pagination from 'react-bootstrap/Pagination';

const Paginator = React.forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [active, setActive] = useState(null);

    useImperativeHandle(ref, () => ({
        reset() {            
            verifyPage(0);
        }
    }));

    useEffect(() => {
        //alert("activePage changed")
        //console.log(props.activePage || 0)
        verifyPage(props.activePage || 0)
    }, [props.activePage]);

    const isPageInvalid = (page) => {
        return (page < 0 || page > (props?.pageCount || 1 /*casos de resultados vacios*/ ) - 1);
    }

    const paginatorText = () => {
        if (props?.pageCount) {
            var start = ((active + 1) - 1) * props?.pageSize + 1;
            var end = Math.min(start + props?.pageSize - 1, props?.total);
            return (`${start} ${t("to")} ${end} ${t("of")} ${props?.total}`);
        } else {
            return "";
        }
    }
    const verifyPage = (page) => {

        //alert(page)
        /*if (page == -1) { //Refresh current or previous or first
            var previousPage = active - 1;
            var isCurrentInvalid = isPageInvalid(active);
            var isPreviousInvalid = isPageInvalid(previousPage);
            console.log("active: " + active)
            console.log("pageCount: " + props?.pageCount)
            console.log("previousPage: " + previousPage)
            console.log("isCurrentInvalid: " + isCurrentInvalid)
            console.log("isPreviousInvalid: " + isPreviousInvalid)
            props?.changePage?.(isCurrentInvalid ? (isPreviousInvalid ? previousPage : 0) : active);
            return;
        }*/
        /*console.log("verifyPage called")
        console.log("pageCount: " + props?.pageCount)
        console.log("page: " + page);
        console.log("IsPageInvalid: " + (isPageInvalid(page)));*/
        if (isPageInvalid(page))
            return;

        setActive(page);
        props?.changePage?.(page);
    }

    return (

        <Stack direction="horizontal">
            {/*props?.isLoading && <Skeleton height={38} count={0.15} />*/}
            {/*!props?.isLoading && */
                <Pagination style={{ margin: "0px" }}>
                    <Pagination.First onClick={() => { if (props?.pageCount > 1) verifyPage(0) }} />
                    <Pagination.Prev onClick={() => { verifyPage(active - 1) }} />

                    {Array.from({ length: props.pageCount || 0 }).map((_, index) => (
                        <Pagination.Item key={index} active={index === active} onClick={() => verifyPage(index)}>
                            {index + 1}
                        </Pagination.Item>)
                    )}
                    <Pagination.Next onClick={() => { verifyPage(active + 1) }} />
                    <Pagination.Last onClick={() => { if (props?.pageCount > 1) verifyPage(props?.pageCount - 1) }} />
                </Pagination>}

            <span className="ms-auto">{paginatorText()}</span>
        </Stack>

    );
});

export default observer(Paginator);
